import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';

import styles from './quote.module.scss';

import QuoteIcon from './svg/quote.inline.svg';

const cx = classNames.bind(styles);

const Quote = ({ text, caption }) => (
  <div className={cx('wrapper')}>
    <div className="container">
      <figure className={cx('content')}>
        <QuoteIcon className={cx('icon')} />
        <blockquote>
          <Heading
            className={cx('text')}
            tag="p"
            size="xl"
            innerHTML={`<span style="min-width: 40px; display: inline-block;"></span>${text}`}
          />
        </blockquote>
        <figcaption>
          <p className={cx('caption')}>{caption}</p>
        </figcaption>
      </figure>
    </div>
  </div>
);

Quote.propTypes = {
  text: PropTypes.node.isRequired,
  caption: PropTypes.string.isRequired,
};

export default Quote;
